<template>
  <li class="list-group-item"
      @click="onItemClick">
    <div class="event-item" >
      <component :is="eventForm"
                 ref="form"
                 :data="event.data">
      </component>

      <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
        <span aria-hidden="true">
          <img src="@/assets/img/static/b-icon_close_x.svg" alt="">
        </span>
      </button>
    </div>
  </li>
</template>

<script>
  import NotificationType from '@/api/types/notification-type'

  import AccreditationRequestForm from './events/AccreditationRequest'
  import AccreditationDeclinedForm from './events/AccreditationDeclined'
  import AccreditationExpiredForm from './events/AccreditationExpired'
  import AccreditationApprovedForm from './events/AccreditationApproved'
  import RetendPublishedForm from './events/RetendPublished'
  import TenderPublishedForm from './events/TenderPublished'
  import TenderInvitedPublishedForm from './events/TenderInvitedPublished'
  import TenderModifiedForm from './events/TenderModified'
  import ProtocolAttachedForm from './events/ProtocolAttached'
  import DraftProtocolAttachedForm from "./events/DraftProtocolAttached";
  import SignatureRequestForm from './events/SignatureRequest'
  import QuestionReceivedForm from './events/QuestionReceived'
  import ComplaintReceivedForm from './events/ComplaintReceived'
  import RequestClarificationRequestedForm from './events/RequestClarificationRequested'
  import RequestClarificationReceivedForm from './events/RequestClarificationReceived'
  import BidClarificationRequestedForm from './events/BidClarificationRequested'
  import BidClarificationReceivedForm from './events/BidClarificationReceived'
  import TenderFinishedForm from './events/TenderFinished'
  import LotCommentedByOrgForm from './events/LotCommentedByOrg'
  import LotCommentedByParticipantForm from './events/LotCommentedByParticipant'
  import LotCommentUpdatedByOrgForm from './events/LotCommentUpdatedByOrg'
  import LotCommentUpdatedByParticipantForm from './events/LotCommentUpdatedByParticipant'
  import LotCancelledForm from './events/LotCancelled'
  import TenderCommittedForApproveForm from './events/TenderCommittedForApprove'
  import RetendProtocolSigned from './events/RetendProtocolSigned'
  import LotCancelledRequest from './events/LotCancelledRequest'
  import LotApprovalRequestForm from './events/LotApprovalRequest'
  import LotApprovedForm from './events/LotApproved'
  import LotDeclinedForm from './events/LotDeclined'
  import LotBidAdjustAllowedForm from './events/LotBidAdjustAllowed'
  import LotBidDeclinedForm from './events/LotBidDeclined'
  import LotBidAcceptedForm from './events/LotBidAccepted'
  import LotBidSuspendedForm from './events/LotBidSuspended'
  import LotCriteriaAdjustAllowedForm from './events/LotCriteriaAdjustAllowed'
  import LotDocumentAdjustAllowedForm from './events/LotDocumentAdjustAllowed'
  import RetendStartedForm from './events/RetendStarted'
  import RetendSentForApproval from "./events/RetendSentForApproval";

  const Events = {};

  Events[NotificationType.ACCREDITATION_REQUEST] = AccreditationRequestForm;
  Events[NotificationType.ACCREDITATION_APPROVED] = AccreditationApprovedForm;
  Events[NotificationType.ACCREDITATION_DECLINED] = AccreditationDeclinedForm;
  Events[NotificationType.ACCREDITATION_EXPIRED] = AccreditationExpiredForm;
  Events[NotificationType.RETEND_PUBLISHED] = RetendPublishedForm;
  Events[NotificationType.TENDER_MODIFIED] = TenderModifiedForm;
  Events[NotificationType.PROTOCOL_ATTACHED] = ProtocolAttachedForm;
  Events[NotificationType.DRAFT_PROTOCOL_ATTACHED] = DraftProtocolAttachedForm;
  Events[NotificationType.SIGNATURE_REQUEST] = SignatureRequestForm;
  Events[NotificationType.QUESTION_RECEIVED] = QuestionReceivedForm;
  Events[NotificationType.COMPLAINT_RECEIVED] = ComplaintReceivedForm;
  Events[NotificationType.TENDER_PUBLISHED] = TenderPublishedForm;
  Events[NotificationType.REQUEST_CLARIFICATION_REQUESTED] = RequestClarificationRequestedForm;
  Events[NotificationType.REQUEST_CLARIFICATION_RECEIVED] = RequestClarificationReceivedForm;
  Events[NotificationType.BID_CLARIFICATION_REQUESTED] = BidClarificationRequestedForm;
  Events[NotificationType.BID_CLARIFICATION_RECEIVED] = BidClarificationReceivedForm;
  Events[NotificationType.TENDER_INVITED_PUBLISHED] = TenderInvitedPublishedForm;
  Events[NotificationType.TENDER_FINISHED] = TenderFinishedForm;
  Events[NotificationType.LOT_COMMENTED_BY_ORG] = LotCommentedByOrgForm;
  Events[NotificationType.LOT_COMMENTED_BY_PARTICIPANT] = LotCommentedByParticipantForm;
  Events[NotificationType.LOT_COMMENT_UPDATED_BY_ORG] = LotCommentUpdatedByOrgForm;
  Events[NotificationType.LOT_COMMENT_UPDATED_BY_PARTICIPANT] = LotCommentUpdatedByParticipantForm;
  Events[NotificationType.LOT_CANCELLED] = LotCancelledForm;
  Events[NotificationType.TENDER_COMMITTED_FOR_APPROVE] = TenderCommittedForApproveForm;
  Events[NotificationType.RETEND_PROTOCOL_SIGNED] = RetendProtocolSigned;
  Events[NotificationType.LOT_CANCELLED_REQUEST] = LotCancelledRequest;
  Events[NotificationType.LOT_APPROVAL_REQUEST] = LotApprovalRequestForm;
  Events[NotificationType.LOT_APPROVED] = LotApprovedForm;
  Events[NotificationType.LOT_DECLINED] = LotDeclinedForm;
  Events[NotificationType.BID_SUSPENDED] = LotBidSuspendedForm;
  Events[NotificationType.LOT_BID_ADJUST_ALLOWED] = LotBidAdjustAllowedForm;
  Events[NotificationType.LOT_CRITERION_ADJUST_ALLOWED] = LotCriteriaAdjustAllowedForm;
  Events[NotificationType.LOT_DOCUMENT_ADJUST_ALLOWED] = LotDocumentAdjustAllowedForm;
  Events[NotificationType.RETEND_STARTED] = RetendStartedForm;
  Events[NotificationType.BID_DECLINED] = LotBidDeclinedForm;
  Events[NotificationType.BID_ACCEPTED] = LotBidAcceptedForm;
  Events[NotificationType.RETEND_SENT_FOR_APPROVAL] = RetendSentForApproval;

  export default {
    props: {
      event: Object,
      required: true
    },

    computed: {
      eventForm() {
        return Events[this.event.type.valueOf()];
      }
    },

    methods: {
      onItemClick() {
        if (this.$refs.form.onClick) {
          this.$refs.form.onClick();
        }

        this.$emit('close');

        this.$store.dispatch('markReadNotifications', {
          objectId: this.event.objectId,
          type: this.event.type
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .close {
    position: absolute;
    top: 0px;
    right: 0px;

    img {
      width: 14px;
      height: auto;
    }
  }

  .event-item {
    padding-right: 24px;

    p {
      &.a-input {
        font-size: 14px;
      }
    }
  }
</style>
